export enum ExamDojoFeatureFlag {
  Testing = 'testing',
  TestingLock = 'testing_lock',
  Billing = 'billing',
  Challenge = 'challenge',
  AsyncGrading = 'async_grading',
  IssueReport = 'issue_report',
  DialogWrapperFix = 'dialog_wrapper_fix',
  MinimumRequiredVersion = 'minimum_required_version',
  Maintenance = 'maintenance',
  ForceOldQuestionFormat = 'force_old_question_format',
  NewQuestionLayout = 'new_question_layout',
  QuestionBank = 'question_bank',
}
